import stripIndent from 'strip-indent'

/**
 * The standard non-breaking space character.
 */
export const nbsp = '\xa0' as const

/**
 * The html entity for non-breaking space.
 */
export const nbspEntity = '&nbsp;'

/**
 * Capitalize the first letter of a string
 */
export function capitalize(text: string): string {
  return text.replace(/(^\w)/g, (m) => m.toUpperCase())
}

export function isEmptyOrBlankSpaces(text: string): boolean {
  return text === '' || text.match(/^\s*$/) !== null
}

export function joinWithAnd(labels: string[], and: string): string {
  if (labels.length <= 1) return labels.join('')
  return `${labels.slice(0, -1).join(', ')} ${and} ${labels[labels.length - 1]}`
}

/**
 * Removes all the accents and special characters from a string (e.g. : œ -> oe, é -> e, ñ -> n, etc.)
 * The map comes from https://stackoverflow.com/a/71408065
 */

export const diacriticsReplacementMap: Record<string, string> = {
  ä: 'ae',
  æ: 'ae',
  ǽ: 'ae',
  đ: 'd',
  ð: 'd',
  ƒ: 'f',
  ħ: 'h',
  ı: 'i',
  ł: 'l',
  ø: 'o',
  ǿ: 'o',
  ö: 'oe',
  œ: 'oe',
  ß: 'ss',
  ŧ: 't',
  ü: 'ue',
  Ä: 'AE',
  Æ: 'AE',
  Ǽ: 'AE',
  Đ: 'D',
  Ð: 'D',
  Ƒ: 'F',
  Ħ: 'H',
  I: 'I',
  Ł: 'L',
  Ø: 'O',
  Ǿ: 'O',
  Ö: 'OE',
  Œ: 'OE',
  ẞ: 'SS',
  Ŧ: 'T',
  Ü: 'UE',
}

export function removeAccentsAndSpecialCharacters(text: string): string {
  return replaceDiacritics(text).replace(/[^a-zA-Z0-9]/g, '')
}

export function replaceDiacritics(text: string): string {
  return text.normalize('NFKD').replace(/./g, function (a) {
    return diacriticsReplacementMap[a] || a
  })
}

/**
 * Detects a common minimal indent of all the input lines, removes it from every line and trim the result
 *
 * @param text
 * @returns
 */
export function trimIndent(text: string): string {
  return stripIndent(text).trim()
}

/**
 * Accent- and punctuation-insensitive French text, for comparing two printed wordings.
 */
export function normalizeFrenchText(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}
